export default __webpack_public_path__ + "static/custom-marker-shapes-24c43695750ce8ddcf02ef099ac984c5.png";